import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";
import RestoreFromTrash from "@mui/icons-material/RestoreFromTrash";
import { useMyDeletedDocuments, useRestoreContract, useRestoreNonGameContract } from "@seabrookstudios/pitch2table";
import { formatFullDate } from "../core/date-formatting";
import { NoItemsFound } from "../publisher/NoItemsFound";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import { idExtractor, useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").DocumentListEntryGame} props.contract
 */
const DeletedGameContractItem = ({ contract }) => {
  const restoreContract = useRestoreContract(contract.refId, contract.id);

  const handleRestore = async () => {
    await restoreContract.mutateAsync();
  };

  const displayName = contract.name || "Unnamed Contract";
  const displayDate = contract.signedDate || contract.uploadedTimestamp;

  return (
    <ListItem>
      <ListItemText primary={displayName} secondary={`Last updated: ${formatFullDate(displayDate)}`} />
      <ListItemIcon>
        <Tooltip title="Restore contract">
          <IconButton onClick={handleRestore} color="primary">
            {restoreContract.isPending ? <CircularProgress size={20} /> : <RestoreFromTrash />}
          </IconButton>
        </Tooltip>
      </ListItemIcon>
    </ListItem>
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").DocumentListEntryPublisher} props.contract
 */
const DeletedPublisherContractItem = ({ contract }) => {
  const restoreContract = useRestoreNonGameContract(contract.refId, contract.id);

  const handleRestore = async () => {
    await restoreContract.mutateAsync();
  };

  const displayName = contract.name || "Unnamed Contract";
  const displayDate = contract.signedDate || contract.uploadedTimestamp;

  return (
    <ListItem>
      <ListItemText primary={displayName} secondary={`Last updated: ${formatFullDate(displayDate)}`} />
      <ListItemIcon>
        <Tooltip title="Restore contract">
          <IconButton onClick={handleRestore} color="primary">
            {restoreContract.isPending ? <CircularProgress size={20} /> : <RestoreFromTrash />}
          </IconButton>
        </Tooltip>
      </ListItemIcon>
    </ListItem>
  );
};

const EmptyBin = () => {
  return (
    <NoItemsFound>
      <Alert severity="info">No deleted items found.</Alert>
    </NoItemsFound>
  );
};

const RecyclingBinItem = ({ item }) => {
  return item.refType === "GameId" ? (
    <DeletedGameContractItem contract={item} />
  ) : (
    <DeletedPublisherContractItem contract={item} />
  );
};

export const RecyclingBin = () => {
  const useMakeList = useMakeListBuilder(RecyclingBinItem, idExtractor, "Recycling Bin", EmptyBin);
  const ListAndDetail = useMakeListAndDetail(useMyDeletedDocuments, [], "recycling-bin", useMakeList);

  return <ListAndDetail />;
};
